import { AddressGet } from '../models/address-get';

export class AdminStudentSearchResult {
  id: string;
  firstName: string;
  middleName: string;
  lastName: string;
  formattedName: string;
  address: AddressGet;
  phone: string;
  cellPhone: string;
  email: string;
}



// WEBPACK FOOTER //
// ./src/app/models/admin-student-search-result.ts